import { createFileRoute } from '@tanstack/react-router';
import SectionAddPage from '@/features/resume-builder/section-add';

/** Adicionar em duas etapas (RN-10): `?etapa=tipo` → `?etapa=formulario&tipo=<key>`. */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/$section/nova')({
  component: SectionAddPage,
});
